import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';
import * as fromState from './state';
import { PasswordResetStep } from '../../models';

export const reducer = createReducer(
  fromState.initialState,
  on(fromActions.createPasswordResetRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.createPasswordResetSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(fromActions.createPasswordResetFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.checkTokenRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.checkTokenSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
    step: 'password_step' as PasswordResetStep,
  })),
  on(fromActions.checkTokenFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.confirmPasswordResetRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.confirmPasswordResetSuccess, () => fromState.initialState),
  on(fromActions.confirmPasswordResetFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.resetState, () => fromState.initialState),
);

export function passwordResetReducer(
  state: fromState.State | undefined,
  action: Action,
) {
  return reducer(state, action);
}
